import React , { Component } from "react";
import { Link } from "react-router-dom";
import { FiX, FiMenu } from "react-icons/fi";
import { withTranslation } from 'react-i18next';

import logoDefault from "../../assets/images/logo/logo.png";
import logoLight from "../../assets/images/logo/logo-light.png";
import logoDark from "../../assets/images/logo/logo-dark.png";
import logoSymbolDark from "../../assets/images/logo/logo-symbol-dark.png";
import logoSymbolLight from "../../assets/images/logo/logo-symbol-light.png";

class Header extends Component {
  constructor(props) {
    super(props);

    this.menuTrigger = this.menuTrigger.bind(this);
    this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);

    this.state = {
      currentLang: this.props.i18n.language || 'es',
    };

    this.changeLanguage = this.changeLanguage.bind(this);
  }

  changeLanguage(lang) {
    this.props.i18n.changeLanguage(lang);
    this.setState({ currentLang: lang });
  }

  componentDidMount() {
    const elements = document.querySelectorAll(".has-droupdown > a");
    elements.forEach(el => {
      el.onclick = function (e) {
        const submenu = this.parentElement.querySelector(".submenu");
        if (submenu) {
          e.preventDefault();
          submenu.classList.toggle("active");
          this.classList.toggle("open");
        }
      };
    });
  }

  menuTrigger() {
    document.querySelector(".header-wrapper")?.classList.toggle("menu-open");
  }

  CLoseMenuTrigger() {
    document.querySelector(".header-wrapper")?.classList.remove("menu-open");
  }

  render() {
    const { logo, color = "default-color", t } = this.props;

    let logoUrl;
    switch (logo) {
      case "light":
        logoUrl = <img src={logoLight} alt="Logo Black Slate" />;
        break;
      case "dark":
        logoUrl = <img src={logoDark} alt="Logo Black Slate" />;
        break;
      case "symbol-dark":
        logoUrl = <img src={logoSymbolDark} alt="Logo Black Slate" />;
        break;
      case "symbol-light":
        logoUrl = <img src={logoSymbolLight} alt="Logo Black Slate" />;
        break;
      default:
        logoUrl = <img src={logoDefault} alt="Logo Black Slate" />;
    }

    return (
      <header className={`header-area formobile-menu header--transparent ${color}`}>
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">{logoUrl}</a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <ul className="mainmenu">
                <li className="has-droupdown">
                  <Link to="/about">{t('Empresa')}</Link>
                </li>
                <li className="has-droupdown">
                  <Link to="#">{t('La pizarra')}</Link>
                  <ul className="submenu">
                    <li><Link to="/slate-v-phyllite">{t('Caracteristicas')}</Link></li>
                    <li><Link to="/process">{t('Procesos')}</Link></li>
                    <li><Link to="the-quarries">{t('Las canteras')}</Link></li>
                  </ul>
                </li>
                <li className="has-droupdown">
                  <Link to="#">{t('Producto')}</Link>
                  <ul className="submenu">
                    <li><Link to="/product-outside">{t('Exterior')}</Link></li>
                    <li><Link to="/product-inside">{t('Interior')}</Link></li>
                    <li><Link to="/product-facades">{t('Fachadas')}</Link></li>
                    <li><Link to="/product-pools">{t('Piscinas')}</Link></li>
                    <li><Link to="/product-colors-finishes">{t('Colores y acabados')}</Link></li>
                    <li><Link to="/product-custom">{t('custom')}</Link></li>
                  </ul>
                </li>
                <li className="has-droupdown">
                  <Link to="/contact">{t('Contacto')}</Link>
                </li>

                {/* Idioma con menú desplegable */}
                <li className="has-droupdown">
                  <a href="#">
                    <img
                      src={this.state.currentLang === 'es' ? "https://flagcdn.com/w40/es.png" : "https://flagcdn.com/w40/us.png"}
                      alt="Idioma actual"
                      style={{ width: "20px", marginRight: "8px", verticalAlign: "middle" }}
                    />
                    {this.state.currentLang === 'es' ? 'Español' : 'English'}
                  </a>
                  <ul className="submenu">
                    <li>
                      <a href="#" onClick={() => this.changeLanguage('es')}>
                        <img src="https://flagcdn.com/w40/es.png" alt="Español" style={{ width: "20px", marginRight: "8px" }} />
                        Español
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => this.changeLanguage('en')}>
                        <img src="https://flagcdn.com/w40/us.png" alt="English" style={{ width: "20px", marginRight: "8px" }} />
                        English
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>

            {/* Botón hamburguesa */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={this.menuTrigger} className="menutrigger text-white">
                <FiMenu />
              </span>
            </div>
            <div className="close-menu d-block d-lg-none">
              <span onClick={this.CLoseMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withTranslation()(Header);
